export default function (RestangularProvider) {
    RestangularProvider.addResponseInterceptor(function(data, operation, what, url, response) {
        if (operation == "getList" || operation == "get") {
            if(data instanceof Array) response.data.map(parse);
            else response.data = parse(response.data);
        }
        return data;
    });
};

function parse(obj){
    if(obj.hardness_initial){
        var newValue = [];

        for(var i in obj.hardness_initial){
            newValue.push({key: i, value: obj.hardness_initial[i]});
        }
        obj.hardness_initial = newValue;
    }
    if(obj.competences){
        var newValue = [];

        for(var i in obj.competences){
            newValue.push(obj.competences[i].id);
        }
        obj.competences = newValue;
    }

    if(obj.licences_type){
        var newValue = [];

        for(var i in obj.licences_type){
            newValue.push(obj.licences_type[i].id);
        }
        obj.licences_type = newValue;
    }
    if(obj.licencesType){
        var newValue = [];

        for(var i in obj.licencesType){
            newValue.push(obj.licencesType[i].id);
        }
        obj.licencesType = newValue;
    }
    if(obj.roles){
        var newValue = obj.roles[0];

        obj.roles = newValue;
    }
    if(obj.modify_variable){
        var newValue = [];

        for(var i in obj.modify_variable){
            newValue.push({key: i, value: obj.modify_variable[i]});
        }
        obj.modify_variable = newValue;
    }
    if(obj.modify_relation){
        var newValue = [];

        for(var i in obj.modify_relation){
            newValue.push({key: i, value: obj.modify_relation[i]});
        }
        obj.modify_relation = newValue;
    }

    if(obj.variable){
        obj.variable = {
            id : obj.variable.id,
            name : obj.variable.name
        };
    }
}



/** WEBPACK FOOTER **
 ** ./js/config/response_interceptor.js
 **/